import styled, { css } from 'styled-components'

import {
    RedButtonOnDisable,
    MenuIcon as _MenuIcon,
} from 'components/Controls/styles'
import { isDesktop } from 'utils/device'

export const BtnWrapper = styled.div`
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    ${isDesktop &&
        css`
            width: 35px;
            height: 35px;
        `}
    ${props => props.disabled && 'cursor:  not-allowed;'}
`

export const AnimWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
`

export const Button = styled(RedButtonOnDisable)`
    position: absolute;
    margin: 0 !important;
    top: 0 !important;
    right: 0 !important;

    background: transparent;
    border: none;

    &:hover {
        border: none !important;
        background-color: transparent !important;
    }
`

export const MenuIcon = styled(_MenuIcon)`
    filter: none;
`
